import { CloseCircleIcon, CloseIcon } from '@instamojo/icons';
import classnames from 'classnames';
import React from 'react';

export interface DrawerProps {
  heading?: string;
  showCloseIcon?: boolean;
  children: React.ReactNode;
  closeDrawer: () => void;
  backdropColor?: string;
  onClose: () => void;
  className?: string;
  isCloseCircleIcon?: boolean;
  drawerBodyClassNames?: string;
}

const Drawer: React.FC<DrawerProps> = ({
  closeDrawer,
  children,
  backdropColor = 'bg-modal-backdrop',
  onClose,
  className = '',
  isCloseCircleIcon = false,
  drawerBodyClassNames = '',
}) => {
  const drawerClassNames = className;
  return (
    <div className="fixed z-999 inset-0 overflow-y-auto">
      <div>
        <div className="fixed inset-0 transition-opacity">
          <div
            className={`absolute inset-0 ${backdropColor} bg-modal-grey bg-opacity-60 cursor-pointer`}
            onClick={() => closeDrawer()}
          ></div>
        </div>
        <div
          className={classnames(
            `inline-block max-w-1024 align-middle bg-white text-left shadow-xl transform transition-all w-full ${drawerClassNames}`,
          )}
        >
          <div className="relative w-full flex justify-end h-0">
            <div className="zoomIn absolute z-9999 rounded-full right-0 cursor-pointer p-12 mr-16 mt-16 w-36 h-36 bg-quantity-bg flex justify-center items-center">
              {isCloseCircleIcon ? (
                <div
                  onClick={() => {
                    onClose();
                  }}
                >
                  <CloseCircleIcon color="red" />
                </div>
              ) : (
                <div
                  onClick={() => {
                    onClose();
                  }}
                >
                  <CloseIcon />
                </div>
              )}
            </div>
          </div>
          <div className={`bg-white text-label overflow-y-scroll ${drawerBodyClassNames}`}> {children}</div>
        </div>
      </div>
    </div>
  );
};

export default Drawer;
